import React, { Fragment, useState } from 'react';
import styled from 'styled-components';
import editIcon from "../../../../assets/images/icons/edit.png";
import plusIcon from "../../../../assets/images/icons/plusCircle.png";
import { ThemeProps } from '../../../genericComponents/globalStyles';
import ResearchModal from './modals/ResearchModal';

export default function Research(props) {
  const {
    researches,
    addNewResearch,
    editResearch,
    deleteResearch,
  } = props;

  /* state modal display */
  const [researchState, setResearchState] = useState();
  const [ResearchModalState, setResearchModalState] = useState(false);

  function onAddNewResearch(research) {
    addNewResearch(research);
    hideResearchModal();
  };
  function onEditResearch(research) {
    editResearch(research);
    hideResearchModal();
  };
  function onDeleteResearch(research) {
    deleteResearch(research);
    hideResearchModal();
  };
  function hideResearchModal() {
    setResearchState(undefined)
    setResearchModalState(false);
  }

  return (
    <Fragment>
      <ResearchModal
        addNewResearch={onAddNewResearch}
        editResearch={onEditResearch}
        deleteResearch={onDeleteResearch}
        isShow={ResearchModalState}
        onHide={hideResearchModal}
        editValues={researchState}
      />
      <RowLayout>
        <Text fontSize={"2.1"} marginBottom={"32"}>Research</Text>
        <IconButton onClick={() => setResearchModalState(true)}>
          <img src={plusIcon} style={{ width: 30, height: 30 }} />
        </IconButton>
      </RowLayout>
      {researches?.length === 0 && (<Text fontSize={"1.5"}>There is no experiences available</Text>)}
      {researches?.map((item, index) => (
        <ExperienceContainer key={index}>
          <RowLayout>
            <Text fontSize={"1.8"}>{item.work_title}</Text>
            <IconButton
              onClick={() => {
                setResearchState(item);
                setResearchModalState(true);
              }}
            >
              <img src={editIcon} style={{ width: 20, height: 18 }} />
            </IconButton>
          </RowLayout>
          <Text fontSize={"1.2"} color={ThemeProps.color.darkGreen}>
            {item.event_date} • {item.event_name}
          </Text>
          {item.show_link === true && (
            <WrapperButton onClick={() => window.open(item.link)}>{'Go to Publication ->'}</WrapperButton>
          )}
        </ExperienceContainer>
      ))
      }
    </Fragment >
  )
}

const ExperienceContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 12px 0;
  border-bottom: 1px solid #ddd;
`;
const RowLayout = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
const Text = styled.p`
  color: ${p => p.color || null};
  font-size: ${(p) => p.fontSize}em;
  margin-bottom: ${(p) => p.marginBottom || "8"}px;
`;
const IconButton = styled.button`
  width: 40px;
  height: 40px;
  background: none;
  outline: none;
  border: none;
`;
const WrapperButton = styled.button`
  background: none;
  outline: none;
  border: none;
  font-weight: bold;
  font-size: 1.3em;
  padding: 4px 8px;
  color: ${ThemeProps.color.primary};
  display: flex;
  align-self: flex-end;
`;